import React from 'react';
import { Form, Input, Button,Spin,Select } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;


const { Option } = Select;

class RegistrationForm extends React.Component {

  state = {
    form_name:'' ,  
    datarequested:true,
    period:'',
    form_number:'',
    form_attachment:null,   

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({datarequested:false})


  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('form_name', this.state.form_name);
    form_data.append('form_number', this.state.form_number);

    this.state.form_attachment==null?
    console.log("No file attachment")
    :
    form_data.append('form_attachment', this.state.form_attachment, this.state.form_attachment?this.state.form_attachment.name:"");

    axios.post(serverconfig.backendserverurl+'/api/registration_forms/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    .then(res => {

    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()
    }).catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="form_name"
        name="form_name"
        rules={[
          {
            required: true,
            message: 'Please input form_name',
          },
        ]}
      >
        <Input name="form_name" 
         placeholder="form_name."
         value={this.state.form_name} 
         onChange={(val)=>{this.setState({form_name:val.target.value})}} />
      </FormItem>


      <FormItem label="form_number">
        <Input
            placeholder="form_number"
            type='number'
            value={this.state.form_number}
            onChange={(val)=>{this.setState({form_number:val.target.value})}}
          />
        
      </FormItem>

  
      <Form.Item label="File">
          <Input  type="file" 
          accept=".pdf" 
          placeholder="PDF" 
          onChange={(e) => this.setState({ form_attachment: e.target.files[0]})}/>
        </Form.Item>  



      <FormItem>
        <Button  type="primary" htmlType="submit">Uplaod Form</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default RegistrationForm;



